import type { User } from "@auth0/auth0-react";
import { type ConfigApp } from "@package/ui-config";
import type { WritableDraft } from "immer";
import { createContext, useContext } from "react";

export type TokenDecoded = {
  "https://v1.panoscape.app/roles"?: string[];
  "https://v1.panoscape.app/permissions"?: string[];
  "https://v1.panoscape.app/organizations"?: string[];
  "https://v1.panoscape.app/email"?: string[];
  "https://v1.panoscape.app/device"?: string;
  "https://v1.panoscape.app/device_organization"?: string;
  aud?: string[];
  azp?: string;
  exp?: number;
  iat?: number;
  iss?: string;
  sub?: string;
  scope: string;
};

export type AuthContextState = {
  authorizedApps: ConfigApp[];
  user?: User;
  token?: string;
  tokenDecoded?: TokenDecoded;
  update: (callback: (draft: WritableDraft<AuthContextState>) => void) => void;
};

export const defaultAuthContextState: AuthContextState = {
  authorizedApps: [],
  update: () => undefined,
};

export const AuthStateContext = createContext<AuthContextState>(
  defaultAuthContextState,
);
export const useAuthState = () => useContext(AuthStateContext);
